/** ISK / FC 错误展示：短摘要 + 是否值得展开全文 */

export function summarizeIskErrorMessage(raw: string | null | undefined): {
  summary: string;
  full: string;
  expandable: boolean;
} {
  const full = String(raw || '').trim();
  if (!full) {
    return { summary: '生成失败', full: '', expandable: false };
  }

  let summary = full;
  if (/keliriji-oss\.keliriji-oss|Hostname\/IP does not match certificate/i.test(full)) {
    summary = 'OSS 地址配置错误（endpoint 重复拼了 bucket）。请重新部署 ttq-math-isk（已修 oss-persist）后重试。';
  } else if (/缺少 OSS 配置/i.test(full)) {
    summary = 'OSS 未配置：请在 ttq-math-isk FC 写入 OSS_NEW_* 后重试。';
  } else if (/ttq-math-isk FC/i.test(full) && /HTTP\s*5\d\d/i.test(full)) {
    summary = '直觉草图服务（ttq-math-isk）返回错误，请稍后重试或查看详情。';
  } else if (/DASHSCOPE|Invalid API-key|API.?[Kk]ey/i.test(full)) {
    summary = '生图密钥无效或未配置（DASHSCOPE_API_KEY）。';
  } else if (/超时|timeout|ETIMEDOUT/i.test(full)) {
    summary = '生图超时，请稍后重试。';
  } else {
    // 取首行可读片段
    const firstLine = full.split(/[\n\r]/)[0]?.trim() || full;
    summary = firstLine.length > 72 ? `${firstLine.slice(0, 72)}…` : firstLine;
  }

  const expandable = full.length > summary.length + 8 || /certificate|headers:|socketHandled|aliyuncs\.com/i.test(full);
  return { summary, full, expandable };
}
